export default {
	message: 'Bitte klicken Sie auf die Schaltfläche Synchronisieren, um neue Konten von SM zu unserem System hinzuzufügen!',
	selector: 'Wählen Sie eine Aktie aus',
	button: 'Synchronisieren'
};
